import { Link } from 'react-router-dom'

const AppointmentsTable = ({ p, type }) => {

    const isoToDate = (iso) => {
        // const isoStr1 = '2022-09-20T09:00:00.000Z'
        const date1 = new Date(iso);
        return (date1.toString().slice(0, 10))
    }

    const isoToTime = (iso) => {
        // const isoStr1 = '2022-09-20T09:00:00.000Z'
        const date1 = new Date(iso);
        return (date1.toString().slice(16, 21))
    }

    // Get the last action timestamp for an appointment
    const getLastActionTimestamp = (appointment) => {
        // If there's no action history, use the appointment creation time
        if (!appointment.actionHistory || appointment.actionHistory.length === 0) {
            // Return the appointment creation timestamp (using timing as fallback)
            return appointment.timing;
        }

        // Get the last item in the action history
        const lastHistoryItem = appointment.actionHistory[appointment.actionHistory.length - 1];
        return lastHistoryItem.timestamp;
    }

    // Format date and time for display
    const formatDateTime = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        return date.toLocaleString(undefined, options);
    }

    return (
        <>
            <div className="table-responsive mt-3">
                <table className="table align-middle mb-0">
                    <thead className="table-light">
                        <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Name</th>
                            <th>Action (created/updated on)</th>
                            <th>A.Status</th>
                            <th>Phone#</th>
                            <th>Address</th>
                            {(() => {
                                switch (type) {
                                    case 'Quotation':
                                        return (
                                            <>
                                                <th>Quotation</th>
                                            </>
                                        )
                                    case 'Inquiry':
                                        return (
                                            <>
                                                <th>Approx Est</th>
                                            </>
                                        )
                                    case 'Payment-pending':
                                        return (
                                            <>
                                                <th>Payment</th>
                                                <th>P.Status</th>
                                            </>
                                        )
                                    default:
                                        return null
                                }
                            })()}
                        </tr>

                    </thead>
                    {p && p.map((a) =>
                        <>
                            {/* {a.timing.toLocaleDateString('en-US')} */}
                            <tbody>
                                <tr>
                                    <td>{isoToDate(a.timing)}</td>
                                    <td>{isoToTime(a.timing)}</td>
                                    <td><Link to={`/detail-appointment/${a._id}`}>{a.name}</Link></td>

                                    <td>
                                        {(() => {
                                            // Get the last action timestamp
                                            const lastActionTimestamp = getLastActionTimestamp(a);
                                            const formattedDateTime = formatDateTime(lastActionTimestamp);

                                            switch (a.action) {
                                                case 'Measurement':
                                                    return (
                                                        <>
                                                            <span className='badge rounded-pill bg-primary'>{a.action}</span>
                                                            <small>({formattedDateTime})</small>
                                                        </>
                                                    )
                                                case 'Installation':
                                                    return (
                                                        <>
                                                            <span className='badge rounded-pill bg-info text-dark'>{a.action}</span>
                                                            <small>({formattedDateTime})</small>
                                                        </>
                                                    )
                                                case 'Quotation':
                                                    return (
                                                        <>
                                                            <span className='badge rounded-pill bg-warning text-dark'>{a.action}</span>
                                                            <small>({formattedDateTime})</small>
                                                        </>

                                                    )
                                                case 'General-Inquiry':
                                                    return (
                                                        <>
                                                            <span className='badge rounded-pill bg-secondary'>{a.action}</span>
                                                            <small>({formattedDateTime})</small>
                                                        </>
                                                    )
                                                case 'Production':
                                                    return (
                                                        <>
                                                            <span className='badge rounded-pill bg-success text-dark'>{a.action}</span>
                                                            <small>({formattedDateTime})</small>
                                                        </>
                                                        
                                                    )
                                                default:
                                                    return (
                                                        <>
                                                            <span className=''>{a.action}</span>
                                                            <small>({formattedDateTime})</small>
                                                        </>
                                                    )
                                            }
                                        })()}
                                    </td>

                                    <td>
                                        {a.actionStatus ? (
                                            <span className="badge bg-light-success text-light w-55">
                                                {'Completed'}
                                            </span>
                                        ) : (
                                            <span className="badge bg-light-danger text-light w-55">
                                                {'Pending'}
                                            </span>
                                        )}
                                    </td>
                                    <td>
                                        <a href={`tel:${a.phone}`}>{a.phone}</a>
                                    </td>
                                    <td>
                                        {a.address}
                                    </td>
                                    {(() => {
                                        switch (type) {
                                            case 'Quotation':
                                                return (
                                                    <>
                                                        <td>
                                                            {'$' + a.payment}
                                                        </td>
                                                    </>
                                                )
                                            case 'Inquiry':
                                                return (
                                                    <>
                                                        <td>
                                                            {'$' + a.payment}
                                                        </td>
                                                    </>
                                                )
                                            case 'Payment-pending':
                                                return (
                                                    <>
                                                        <td>
                                                            {'$' + a.payment}
                                                        </td>
                                                        <td>
                                                            {a.paymentStatus ? (
                                                                <span className="badge bg-light-success text-light w-55">
                                                                    {'Completed'}
                                                                </span>
                                                            ) : (
                                                                <span className="badge bg-light-danger text-light w-55">
                                                                    {'Pending'}
                                                                </span>
                                                            )}
                                                        </td>
                                                    </>
                                                )
                                            default:
                                                return null
                                        }
                                    })()}
                                </tr>
                            </tbody>
                        </>
                    )

                    }

                </table>
            </div>
        </>
    )
}

export default AppointmentsTable